<template lang="pug">
  .complete.box
    h1.has-text-weight-bold THANK YOU FOR YOUR FIBRE ORDER
    p.has-text-blue.has-text-weight-bold(v-if="orderNumber") Your order number is&nbsp;
        span.order-number {{ orderNumber }}
    p.has-text-weight-normal You will be contacted within 1 business day via WhatsApp with a provisional schedule.
    LeaveReview

</template>

<script>
  import store from '@/store';
  import LeaveReview from "@/components/LeaveReview.vue";

  export default {
    components: {
      LeaveReview
    },
    data() {
      return {
        orderNumber: store.state.orderNumber
      }
    },
    methods: {

    },
  }
</script>

<style lang="scss">
  @import "~bulma/sass/utilities/mixins";
  @import "../styles/variables";

  .complete {
    margin: 3rem 3rem 0 3rem;
    text-align: left;
    padding: 3rem;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 100%;
    justify-content: left;
    @include until($desktop) {
      flex-direction: column;
    }

    h1 {
      font-size: 2rem;
      line-height: 1.125;
      margin-bottom: 2rem;
    }

    p {
      margin-bottom: 2rem;
    }

    .has-text-blue {
      color: $primary;
    }
    .order-number {
      font-size: 1.25rem;
    }
  }
</style>
